import React from 'react';
import { Box, Text, HStack } from '@gluestack-ui/themed';
import { SectionHeaderProps } from '../types';

/**
 * A section header for the lecturer sidebar.
 */
const SectionHeader: React.FC<SectionHeaderProps> = ({ title, rightAction }) => (
  <Box px="$4" pt="$4" pb="$1.5">
    <HStack alignItems="center" justifyContent="space-between">
      <Text size="2xs" fontWeight="bold" color="$textHint" textTransform="uppercase" letterSpacing={0.5}>
        {title}
      </Text>
      {rightAction}
    </HStack>
  </Box>
);

export default SectionHeader;
